import { makeObservable, computed, observable, action } from "mobx";
import FileManagerModel, {
  IOptions,
} from "../../objects/file/NovaFileManagerModel";
import FileManager from "../../objects/file/manager";
import { parseStatus } from "../../objects/file/utils";
import {
  IRichModalFile,
  EFileSelectErr,
  ERichModalFileParseStatus,
} from "../../objects/file/types";
import globalConfig from "../../objects/globalConfig/store";

interface IFileUploadProps {
  totalToken: number;
}

export enum EValidType {
  file = "file",
  image = "image",
  all = "all",
}

// const maxToken = 100 * 1024;
class FileUploadVm {
  uploadFileManager: FileManagerModel;
  fileUploadProps: IFileUploadProps;
  // fileManager = new FileManager();
  @observable validType = EValidType.all;

  constructor(
    uploadFileManagerProps: IOptions,
    fileUploadProps: IFileUploadProps,
  ) {
    this.uploadFileManager = new FileManagerModel(uploadFileManagerProps);
    this.fileUploadProps = fileUploadProps;
    makeObservable(this);
  }

  // init() {
  //   this.fileManager.listFile();
  // }

  clearFiles() {
    this.uploadFileManager.init();
    this.setValidType(EValidType.all);
  }

  @computed
  get allCompleted(): boolean {
    // return false;
    return this.uploadFileManager.fileList.every(item => {
      const status = parseStatus(item);
      return status === ERichModalFileParseStatus.success;
    });
  }

  // get arriveMaxLen(): boolean {
  //   return (
  //     this.uploadFileManager.fileList.length >=
  //     this.uploadFileManager.maxFileNumber
  //   );
  // }

  get lastFileComprehend(): number {
    const maxToken = globalConfig.max_token - this.fileUploadProps.totalToken;
    const allTokens = this.uploadFileManager.fileList.map(
      item => item.parseInfo?.token || 0,
    );
    let currentTokenNumber = 0;
    for (let i = 0; i < allTokens.length; i++) {
      currentTokenNumber += allTokens[i];
      if (currentTokenNumber > maxToken) {
        if (i < allTokens.length - 1) {
          return 0;
        } else {
          return Math.floor(
            ((allTokens[i] - (currentTokenNumber - maxToken)) / allTokens[i]) *
              100,
          );
        }
      }
    }
    return 100;
    // const len = this.novaFileManager.fileList.length;
    // if (len === 0) return 0;
    // const sortedFileList = this.novaFileManager.fileList.sort((a, b) => {
    //   const aComprehend = a.parseInfo?.comprehend || 0;
    //   const bComprehend = b.parseInfo?.comprehend || 0;

    //   return bComprehend - aComprehend;
    // });

    // return sortedFileList[len - 1]?.parseInfo?.comprehend || 0;
  }

  get inValidate() {
    const illegal = this.uploadFileManager.fileList.some(
      item => parseStatus(item) !== ERichModalFileParseStatus.success,
    );
    return illegal || this.lastFileComprehend <= 0;
  }

  get hasFile() {
    return this.uploadFileManager.fileList.length > 0;
  }

  setFileUploadProps(v: IFileUploadProps) {
    this.fileUploadProps = v;
  }

  deleteFile = (v: IRichModalFile) => {
    this.uploadFileManager.deleteFile(v);
    if (this.uploadFileManager.fileList.length === 0) {
      this.setValidType(EValidType.all);
    }
    // if (this.allCompleted && !this.novaFileManager.parseStatusQuering) {
    //   this.novaFileManager.startQueryFileParseStatus();
    // }
  };

  // addFiles = (addedFiles: File[]) => {
  //   const overMaxCount =
  //     addedFiles.length + this.uploadFileManager.fileList.length >
  //     this.uploadFileManager.maxFileNumber;
  //   if (overMaxCount) {
  //     addedFiles = addedFiles.slice(
  //       0,
  //       this.uploadFileManager.maxFileNumber -
  //         this.uploadFileManager.fileList.length,
  //     );
  //   }

  //   !!addedFiles.length && this.uploadFileManager.addFiles(addedFiles);

  //   if (overMaxCount) {
  //     return EFileSelectErr.OverNumber;
  //   }
  // };

  @action.bound
  setValidType = (val: EValidType) => {
    this.validType = val;
  };
}

export default FileUploadVm;
